import { api } from "../api";
import { backendErrors } from "./common";
import { SIGNUP_STEPS } from "./auth";

export const whiteLabelContact = async (data: any) => {
  const { data: response } = await api.forms.whiteLabel(data);

  if (response.errors || !response.success) {
    throw { errors: backendErrors(response.errors || {}) };
  }

  return {
    next: SIGNUP_STEPS.THANK_YOU_STEP,
    data: response
  };
};
